import React from "react";

export const PostHistorySkeleton: React.FC = () => {
  return (
    <div className="h-fit  py-2">
      <style>{`
        @keyframes shimmer {
          0%   { background-position: -800px 0; }
          100% { background-position: 800px 0; }
        }

        .sk {
          background: linear-gradient(
            90deg,
            #e8e3fb 25%,
            #d5cef5 50%,
            #e8e3fb 75%
          );
          background-size: 800px 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 6px;
        }
      `}</style>

      <div className="w-full mx-auto  space-y-6">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="bg-white border border-gray-100 p-2 rounded-md overflow-hidden"
          >
            <div className="flex items-center justify-between p-4 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="sk w-8 h-8 rounded-full"></div>
                <div>
                  <div className="sk h-4 w-20 mb-2"></div>
                  <div className="sk h-3 w-16"></div>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <div className="sk w-5 h-5 rounded"></div>
                <div className="sk w-5 h-5 rounded"></div>
              </div>
            </div>

            <div className="flex">
              <div className="sk flex-shrink-0 w-32 h-24 m-1 rounded"></div>

              <div className="flex-1 p-4 min-w-0">
                <div className="sk h-4 w-3/4 mb-2"></div>
                <div className="sk h-3 w-full mb-2"></div>
                <div className="sk h-3 w-5/6 mb-2"></div>
                <div className="sk h-3 w-32"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
